var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    attrs: {
      "title": _vm.options.title,
      "visible": _vm.dialogVisible,
      "append-to-body": "",
      "destroy-on-close": "",
      "width": _vm.options.width,
      "fullscreen": _vm.options.fullscreen,
      "modal": _vm.options.showModal,
      "show-close": _vm.options.showClose,
      "close-on-click-modal": _vm.options.closeOnClickModal,
      "close-on-press-escape": _vm.options.closeOnPressEscape,
      "center": _vm.options.center,
      "before-close": _vm.handleBeforeClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleCloseEvent,
      "opened": _vm.handleOpenedEvent
    }
  }, [_c('VFormRender', {
    ref: "dFormRef",
    attrs: {
      "form-json": _vm.formJson,
      "form-data": _vm.formData,
      "option-data": _vm.optionData,
      "global-dsv": _vm.globalDsv,
      "parent-form": _vm.parentFormRef,
      "disabled-mode": _vm.options.disabledMode,
      "dynamic-creation": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.options.cancelButtonHidden) ? _c('el-button', {
    on: {
      "click": _vm.handleCancelClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.cancelBtnLabel))]) : _vm._e(), _vm._v(" "), (!_vm.options.okButtonHidden) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleOkClick
    }
  }, [_vm._v("\n      " + _vm._s(_vm.okBtnLabel))]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e71673","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/dynamic-dialog.vue
// module id = null
// module chunks = 